import React, { useState } from 'react';
import { Drawer, Box, Typography, IconButton } from '@mui/material';
import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions';
import CrossIcon from "../assests/croosicon.png";
import SendIcon from "../assests/send.png";
import SearchItm from '../assests/search.svg'
import MoreIcon from '../assests/more.svg';
import './CommonTicket.css';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import Picker from 'emoji-picker-react';

dayjs.extend(relativeTime);

const TIcketDrawer = ({ drawerOpen, isBelowMd, handleDrawerClose, selectedTicket, messsageData, handleOpen, onCloseTicket, dateFormate, sendMessage, setSendMessage, handleSendMsg,chatRef }) => {

  
  const [emojiPickerOpen, setEmojiPickerOpen] = useState(false);

  const handleEmojiClick = (emoji) => {
    setSendMessage(prevMessage => prevMessage + emoji.emoji);
    setEmojiPickerOpen(false);
  };
  const formatDate = (date) => {
    if (dayjs().isSame(date, 'day')) return 'Today';
    if (dayjs().subtract(1, 'day').isSame(date, 'day')) return 'Yesterday';
    return dayjs(date).format('MMMM D, YYYY');
  };
  

  return (
    <Drawer
      anchor="right"
      open={drawerOpen && isBelowMd}
      onClose={handleDrawerClose}
      sx={{ width: '80%', flexShrink: 1 }}
    >
      {selectedTicket && (
        <Box className="drawer-container">
          <Box className="drawer-header">
            <Typography className="drawer-title">
              {selectedTicket?.title || "N/A"}
            </Typography>
            <IconButton onClick={handleDrawerClose}>
              <img src={CrossIcon} alt="close-icon" className="drawer-close-icon" />
            </IconButton>
          </Box>

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
            {selectedTicket?.status !== 'Closed' && (
              <div style={{ cursor: 'pointer', background: "#362B24", color: '#FFF', width: 'auto', borderRadius: '25px', height: '32px', padding: '8px', fontSize: "12px" }}
                onClick={() => onCloseTicket(selectedTicket?._id)}>Close Ticket</div>
            )}

            <Box className="drawer-more-icon">
              <IconButton onClick={handleOpen}>
                <img src={MoreIcon} alt="view-details-icon" />
              </IconButton>
            </Box>
          </div>

          <Box className="drawer-message-container" ref={chatRef}>
            <Box className="drawer-message-box">
               {messsageData
    .sort((a, b) => dayjs(a.updatedAt).isBefore(dayjs(b.updatedAt)) ? -1 : 1) // Sort messages by timestamp
    .map((message, index) => {
      // Check if we need to display a date separator (if it's a different day)
      const showDate =
        index === 0 ||
        !dayjs(messsageData[index - 1].updatedAt).isSame(message.timestamp, 'day');

      return (
        <React.Fragment key={message?._id}>
          {showDate && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <div
                style={{
                  color: 'gray',
                  fontSize: '12px',
                  background: '#E8E8E8',
                  height: '31px',
                  padding: '7px',
                  borderRadius: '28px',
                  marginBottom: '2px',
                  opacity: '0.6',
                }}
              >
                {formatDate(message?.updatedAt)}
              </div>
            </div>
          )}

          {/* Message Box */}
          <Box
            className={`chat-message ${message.sender ? 'message-incoming' : 'message-outgoing'}`}
            style={{
              textAlign: message.sender ? 'left' : 'right',
              marginBottom: '10px',
            }}
          >
            <Typography
              className="message-text"
              style={{
                
                  
                fontFamily:"Heebo",
                display: 'inline-block',
                maxWidth: '80%',
                wordWrap: 'break-word',
                background: message.sender
                  ? '#E8E8E8'
                  : 'linear-gradient(112deg, #07523D 7.8%, #168F6D 78.62%)', 
                padding: '8px 12px',
                borderRadius: message.sender ? '18px 18px 18px 0px':'18px 18px 0px 18px', 
                color: message.sender ? '#362B24':'white'
              }}
            >
              {message?.message}
            </Typography>

            {/* Timestamp */}
            <Typography
              className="message-time"
              style={{
                fontSize: '11px',
                color: 'gray',
                marginTop: '5px',
                textAlign: message.sender ? 'left' : 'right',
              }}
            >
              {dayjs(message.updatedAt).format('h:mm A')}
            </Typography>
          </Box>
        </React.Fragment>
      );
    })}
            </Box>
          </Box>

          {selectedTicket?.status === "Open" && (
            <Box className="message-input-container">
              <Box className="message-input-box">
                <EmojiEmotionsIcon sx={{ color: '#BDBDBD', marginRight: '8px',cursor:'pointer'}} onClick={() => setEmojiPickerOpen(!emojiPickerOpen)} />
                
                {emojiPickerOpen && (
                  <Box className="emoji-picker-container" >
                    <Picker onEmojiClick={handleEmojiClick}   sx={{
                    height: '500px', // Adjust height as needed
                    width: '400px',}}/>
                  </Box>
                )}

                <input
                  type="text"
                  placeholder="Type a message"
                  value={sendMessage}
                  onChange={(e) => setSendMessage(e.target.value)}
                  className="message-input"
                />

                <div className="send-icon-container" onClick={() => handleSendMsg(selectedTicket?._id)}>
                  <img src={SendIcon} alt="send-icon" className="send-icon" />
                </div>
              </Box>
            </Box>
          )}
        </Box>
      )}
    </Drawer>
  );
};

export default TIcketDrawer;
